import React, { Component } from 'react';
import '../css/topNav.css';
import medicoverLogo from '../images/medicover-hospitals-logo.jpg';

export default class TopNav extends Component {
    render() {
        return (
            <div className='top-bar'>
                <div className='container-fluid'>
                    <div className="row">
                        <div className="col-md-4">
                            <img src={medicoverLogo} alt="logo" className='logo' />
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                            <div className="float-end">
                                <h6>Location</h6>
                                <select name="select" id="seletOption">
                                    <option value="hyderbad">Hyderbad</option>
                                    <option value="vizag">Vizag</option>
                                    <option value="nasik">Nasik</option>

                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
